export enum QueueStatusEnum {
  Initiated = '00000000-0000-0000-0000-000000000001',
  Pending = '00000000-0000-0000-0000-000000000002',
  Completed = '00000000-0000-0000-0000-000000000003',
  Failed = '00000000-0000-0000-0000-000000000004',
  Cancelled = '00000000-0000-0000-0000-000000000005',
  Tracking = '00000000-0000-0000-0000-000000000006'
}
